<template>
  <el-button class="manager-reset-button" native-type="button" :disabled="disabled" @click="$emit('click', $event)">重置</el-button>
</template>

<script>
import Button from 'element-ui/lib/button'
import 'element-ui/lib/theme-chalk/button.css'

export default {
  name: 'ManagerResetButton',
  components: { 'el-button': Button },
  props: { disabled: Boolean }
}
</script>

<style scoped>
.manager-reset-button.el-button {
  display:inline-flex;
  align-items:center;
  justify-content:center;
  flex:0 0 80px;
  width:80px;
  min-width:80px;
  height:40px;
  min-height:40px;
  margin:0;
  padding:0;
  border:1px solid #d6e1de;
  border-radius:5px;
  color:#496467;
  background:#fff;
  font-family:inherit;
  font-size:13px;
  font-weight:500;
  line-height:1;
  letter-spacing:0;
}
.manager-reset-button.el-button:hover:not(:disabled) { border-color:#237f78; color:#237f78; background:#fff; }
.manager-reset-button.el-button:focus-visible { outline:2px solid #237f78; outline-offset:2px; }
.manager-reset-button.el-button:disabled { color:#496467; background:#fff; opacity:.55; cursor:not-allowed; }
</style>
